<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :pathResource="pathResource">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData.accettazione"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Data dal:</label>
                        <date-picker v-model="filtro.dataDal" format="DD-MM-YYYY" value-type="timestamp"
                            placeholder="Seleziona data iniziale" type="date"> </date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Data al:</label>
                        <date-picker v-model="filtro.dataAl" format="DD-MM-YYYY" value-type="timestamp"
                            placeholder="Seleziona data finale" type="date"> </date-picker>
                    </b-col>

                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"
                        class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button v-on:click="onReset" variant="danger">{{
                            this.$i18n.t("patients.lblResetFilter")
                            }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <AccettazioneSsnImpegnativaComponent ref="cmpAccettazioneSsnImpegnativaComponent" :isEdit="true"
                :jsonData="jsonData" @reload="onReload" :component="true" :ricette="ricetteItems"
                @onAggiungiImpegnativa="onAggiungiImpegnativa" />
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";

import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";

import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
import AccettazioneSsnImpegnativaComponent from "../../../accettazione/ssn/components/AccettazioneSsnImpegnativaComponent.vue"
import toast from "../../../../template/layout/utility/sa-toast.js";
export default {
    mixins: [UtilityMixin],
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    props: {
        utente: { type: Object },
    },
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        DatePicker,
        AccettazioneSsnImpegnativaComponent
    },
    data() {
        return {
            idAccettazione: null,
            filtro: {

            },
            ricetteItems: [],
            btnNewVisible: true,
            pathResource: "/progettoriabilitativoindividuale",
            pathResourceAccettazione: "/accettazioni",
            linkback: "/rsagestioneospiti",
            pathResourceRicette: "/accettazionericette",
            listKey: 0,
            jsonData: { accettazione: { accettazioneAnagrafica: {}, accettazioneStruttura: {}, accettazionePresidio: {} }, accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {}, ricette: [] },
            statiPriOptions: [],
        };
    },
    mounted() {
        this.idAccettazione = this.$route.query.idAccettazione;
        // let sessionStorage = window.sessionStorage;
        // if (sessionStorage["filtroPriLista"]) {
        //     this.filtroPriLista = JSON.parse(sessionStorage["filtroPriLista"]);
        // }
        // this.filtroPriLista.idAccettazione = this.$route.query.idAccettazione;
        // me.loadTipologieSchedeValutazione();
        this.loadAccettazione();
    },
    methods: {
        onReload() {
            this.loadAccettazione();
        },
        loadAccettazione() {
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.pathResourceAccettazione + "/" + this.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    this.jsonData.accettazione = response.data.data;
                    this.closeShowModalLoading();
                    this.loadAccettazioneRicette();


                })
                .catch((err) => {
                    console.log(err);
                });
        },
        loadAccettazioneRicette() {
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.pathResourceRicette + "?idAccettazione=" + this.idAccettazione;
            axios
                .get(link)
                .then((response) => {

                    this.ricetteItems = response.data.data.list;
                    this.closeShowModalLoading();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        onAggiungiImpegnativa(jsonRicetta) {
            let ricetta = jsonRicetta;
            ricetta.idAccettazione = this.idAccettazione;
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + "/accettazionericette"

            axios.post(link, ricetta).then((response) => {
                toast.success("Creato con Successo", response.data.data.codiceBar1 + response.data.data.codiceBar2);
                this.closeShowModalLoading();
                this.loadAccettazione();
            }).catch((e) => {
                let messaggio = e.response?.data?.messaggio;
                if (!messaggio) {
                    messaggio = "Errore Grave"
                }
                toast.error(messaggio, "Errore nel salvataggio");
                this.$refs.cmpAccettazioneSsnImpegnativaComponent.showImpegnativa(ricetta);
                this.closeShowModalLoading();
            });


        },

        onSubmit() {
            this.loadAccettazione();
        },
        onReset() {
            this.loadAccettazione();
        },
    },
};
</script>

<style></style>
